import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  merge_cards_skeleton_wrapper: {
    padding: theme.spacing(2),
    position: "relatvive",
  },
  merge_cards_skeleton_background: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.border.secondary}`,
    borderRadius: "12px",
    height: "auto",
    maxHeight: "fit-content",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    padding: "32px 16px 16px 16px",
  },
  cardHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    position: "relative",
    "& .skeleton-wrapper": {
      position: "absolute",
      top: "-70px",
      left: "50%",
      transform: "translateX(-50%)",
      width: "70px",
      height: "70px",
    },
  },
  cardColumns: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  merge_skeleton_arrows_styles: {
    display: "flex",
    position: "fixed",
    bottom: "10px",
    right: "20px",
    flexDirection: "row",
    alignContent: "center",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "24px",
  },
}));
